import React from "react";

import { Box } from "@material-ui/core";
import { selectIsLoading, selectHasErrors, selectNumberOfDirectCompetitors } from "modules/customer/tools/location/competition/competitionSlice";
import { useAppSelector } from "store";
import KPIFact from "components/visuals/KPIFact";

const NumberOfDirectCompetitors: React.FC = () => {
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const directCompetitorsCount = useAppSelector(selectNumberOfDirectCompetitors);
    const kpiValue = String(directCompetitorsCount);
    const label = "Direct competitors within 5km of the selected location";

    return (
        <Box width="100%" height="100%" data-cy="number-of-direct-competitors">
            <KPIFact
                loading={isLoading}
                error={hasErrors}
                label={label}
                value={kpiValue}
            />
        </Box>
    );
};

export default NumberOfDirectCompetitors;
